import { useMediaQuery } from "@mui/material";
import { CallLogsDispositions, LeadData, Status } from "types";
import { Button, Label, Modal, Textarea } from 'flowbite-react';
import Select, { SingleValue } from 'react-select';
import { useState } from "react";
import { MobileDateTimePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";

type Props = {
    isOpen: boolean;
    onClose: () => void;
    logNotes: string;
    setLogNotes: (value: string) => void;
    setOpenAddLogModal: (value: boolean) => void;
    handleAddLogSubmit: () => void;
    setSelectedCallLogStatus: (value: string) => void;
    setSelectedStatus: (value: string) => void;
    setModalContent: (value: string) => void;
    selectedDate?: Date | null;
    setSelectedDate?: React.Dispatch<React.SetStateAction<Date | null>>;
    selectedStatus: string;
    selectedCallLogStatus: string;
};
const callLogToStatusMap: { [key: string]: string[] } = {
    New: ['All leads new by default'],
    NotConnected: ['No POC', 'POC Number not found', 'No Incoming', 'Incorrect Number'],
    DNP: ['DNP 1', 'DNP 2', 'Busy'],
    Positive: ['Hiring', 'Call Back later', 'Will discuss and back'],
    FutureProspect: ['Will Hire Later', 'Position Closed'],
    Qualified: ['Qualified'],
    // Onboarded: ['Onboarded'],
    // ProcessStart: ['Process Start'],
    Unqualified: [
        'DNP 3',
        'Not Hiring Externally',
        'Tech Stack Mismatch',
        'Consultancy',
        'Low CTC',
        'Experience Mismatch',
        '1000+ Employees',
        'Junk Lead',
        'Not right POC',
        'Not Hiring',
    ],
};
export const getStatusForCallLogV2 = (callLog: string): string | undefined => {
    for (const [status, dispositions] of Object.entries(callLogToStatusMap)) {
        if (dispositions.includes(callLog)) {
            return status;
        } else {
            console.log('No matching status found ----');
        }
    }
    return undefined;
};
const AddLogModal = ({
    isOpen, onClose, selectedStatus, selectedDate, setSelectedDate, handleAddLogSubmit, setSelectedCallLogStatus, setSelectedStatus, setModalContent, setLogNotes, logNotes, setOpenAddLogModal, selectedCallLogStatus
}: Props) => {
    const isMobile = useMediaQuery('(max-width:960px)');
    const handleDateTimeChange = (date: Date | null) => {
        console.log('date', date);
        if (setSelectedDate) {
            setSelectedDate(date);
            console.log('after select the date is working');
        } else {
            console.error('setSelectedDate is undefined');
        }
    };
    console.log("selectedDate", selectedDate);
    return (
        <Modal show={isOpen} size="xl" onClose={onClose} dismissible>
            <Modal.Header>
                <h1 className="text-[#1C1C28] dark:text-inherit text-2xl font-inter font-[500]">Add Log</h1>
            </Modal.Header>
            <Modal.Body>
                <div className='flex flex-col gap-2'>
                    <div className='flex flex-col gap-3'>
                        <div className='flex gap-1'>
                            <Label>Call Log Status</Label>
                            <span className="text-[red]">*</span>
                        </div>
                        <Select
                            isClearable={true}
                            menuPlacement={'auto'}
                            classNamePrefix="my-select-plans"
                            closeMenuOnSelect
                            options={Object.values(CallLogsDispositions).map(source => ({ label: source, value: source }))}
                            onChange={(selected: SingleValue<{ label: string; value: string }>) => {
                                if (selected?.value) {
                                    setSelectedCallLogStatus(selected.value);
                                    const status = getStatusForCallLogV2(selected.value);
                                    if (status) {
                                        setSelectedStatus(status);
                                    }
                                    setModalContent(selected.value);
                                }
                            }}
                        />
                        {selectedCallLogStatus === 'Call Back later' && (
                            <div className="w-full">
                                <div className="mb-[8px]">
                                    <Label>{'Select the date and time'}</Label>
                                    <span className="text-[red]">*</span>
                                </div>

                                <MobileDateTimePicker
                                    format="DD MMM, YYYY, hh:mm A"
                                    minutesStep={1}
                                    value={selectedDate ? dayjs(selectedDate) : null}
                                    onChange={(date) => {
                                        if (dayjs(date).isValid()) {
                                            const formattedDate = dayjs(date).format('DD MMM, YYYY, hh:mm A');
                                            handleDateTimeChange(dayjs(formattedDate, 'DD MMM, YYYY, hh:mm A').toDate());
                                        } else {
                                            console.log('Invalid date format');
                                        }
                                    }}
                                    sx={{
                                        '&': { width: '100%' },
                                        '& .MuiInputBase-input': {
                                            padding: '10px',
                                            borderRadius: '8px',
                                            backgroundColor: 'white',
                                            border: '1px solid rgb(209 213 219 / 1)',
                                            fontSize: '14px',
                                        },
                                        '& .MuiInputBase-root': {
                                            outline: 'none',
                                            padding: '0px',
                                            '&:hover': { outline: 'none' },
                                        },
                                        '& fieldset': { display: 'none' },
                                    }}
                                />
                            </div>
                        )}
                        <div className='flex gap-1'>
                            <Label>Status</Label>
                            <span className="text-[red]">*</span>
                        </div>
                        <Select
                            isClearable={true}
                            menuPlacement={'auto'}
                            classNamePrefix="my-select-plans"
                            closeMenuOnSelect
                            options={Object.values(Status).map(source => ({ label: source, value: source }))}
                            value={selectedStatus ? { label: selectedStatus, value: selectedStatus } : null}
                            onChange={(selected: SingleValue<{ label: string; value: string }>) => {
                                if (selected?.value) {
                                    setSelectedStatus(selected.value);
                                }
                            }}
                            isDisabled={true}
                        />
                    </div>
                    <div className='flex flex-col gap-2'>
                        <div className='flex gap-1'>
                            <Label>Remark</Label>
                            <span className="text-[red]">*</span>
                        </div>
                        <Textarea
                            style={{
                                fontFamily: "'Inter', sans-serif",
                                borderRadius: '8px',
                            }}
                            className="min-h-[87px]"
                            value={logNotes}
                            maxLength={640}
                            id="message"
                            name="message"
                            placeholder="Write your message here..."
                            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setLogNotes(e.target.value)}
                        />
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer className='flex justify-end'>
                <Button className='' color='whiteBlueOutline' onClick={() => setOpenAddLogModal(false)}>
                    Cancel
                </Button>
                <Button
                    color='purplePlaced'
                    className="btn btn-primary"
                    onClick={handleAddLogSubmit}
                    disabled={!selectedCallLogStatus || !selectedStatus || !logNotes || (selectedCallLogStatus === 'Call Back later' && !selectedDate)}
                >
                    Add Log
                </Button>
            </Modal.Footer>
        </Modal>

    )
}

export default AddLogModal;